import { devDomain } from './dev.domain';

export const ignoreHosts: string[] = [
  'https://21bit.com',
  'localhost',
  'stage',
  'dev',
  ...devDomain,
];
